<template>
  <div class="bidding-room mt-20">
    <block-head title="竞价大厅" hid-more-btn icon="bidding">
      <!-- <div class="f-start-c flex-1">
        <ul class="ejy-contantor f-start-c">
        <img src="@/assets/images/home/ejylogo.png" />
        <li>会员登录></li>
        <li>竞价登录></li>
        <li>机构入口></li>
        </ul>
      </div> -->
    </block-head>
    <div style="height: 462px; overflow: hidden;">
      <iframe :src="link" frameborder="0" class="bidding-room-body mt-20" />
    </div>
  </div>
</template>

<script>

import BlockHead from "@/views/home/components/BlockHead.vue";

export default {
  name: "BiddingRoom",
  components: { BlockHead },
  props: {
    // patientIn: {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  data() {
    return {};
  },
  // 监听属性 类似于data概念
  computed: {
    link() {
      return process.env.VUE_APP_BIDDING_ROMG_LINK
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {}
};
</script>

<style scoped lang="scss">
.bidding-room{
  .bidding-room-body{
    width: 100%;
    height: 580px;
  }
}
.ejy-contantor{
  width: 363px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 25px;
  border: 1px solid #E4E4E4;
  padding: 7px 13px
}
.ejy-contantor li{
  width: 70px;
  height: 20px;
  background: #E15717;
  border-radius: 10px;
  margin: 0 0 0 15px;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
}
.ejy-contantor li:hover{
  color: #FFFFFF!important;
}
</style>
